import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field } from 'redux-form';
import CountryCodePhoneInput from './countryCodePhoneInput';

export default class CountryCodePhoneInputRedux extends Component {
  constructor(props) {
    super(props);

    this.fieldInput = ({ input, meta, ...attributes }) => {
      let validationError = null;

      if (meta && meta.touched && meta.error) {
        validationError = (<div className="c-input-error-message">{meta.error}</div>);
      }

      return (
        <div className="u-position-relative">
          <CountryCodePhoneInput
            disabled={this.props.disabled}
            {...input}
            {...attributes}
          />
          {validationError}
        </div>
      );
    };
  }

  render() {
    const { name, ...attributes } = this.props;
    if (!name) return null;

    return <Field name={name} component={this.fieldInput} {...attributes} />;
  }
}

CountryCodePhoneInputRedux.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

CountryCodePhoneInputRedux.defaultProps = {
  disabled: false,
};
